import { ContactWorkflowStepActionEnum } from 'modules/contacts/contact-page/enums/contact-workflow-step-action-enum'

export const contactWorkflowActionTitleLocoKeys: Record<ContactWorkflowStepActionEnum, string> = {
  [ContactWorkflowStepActionEnum.AddTag]: 'dashboard.automation_rule.action.add_tag',
  [ContactWorkflowStepActionEnum.RemoveTag]: 'dashboard.automation_rule.action.remove_tag',
  [ContactWorkflowStepActionEnum.SendEmail]: 'dashboard.automation_rule.action.send_email',
  [ContactWorkflowStepActionEnum.SendEmailToSpecificAddress]:
    'dashboard.automation_rule.action.send_email_to_specific_address',
  [ContactWorkflowStepActionEnum.SubscribeToCampaign]:
    'dashboard.automation_rule.action.add_campaign',
  [ContactWorkflowStepActionEnum.UnsubscribeFromCampaign]:
    'dashboard.automation_rule.action.remove_campaign_from_contact',
  [ContactWorkflowStepActionEnum.EnrollInCourse]:
    'dashboard.automation_rule.action.enroll_in_course',
  [ContactWorkflowStepActionEnum.RevokeAccessToCourse]:
    'dashboard.automation_rule.action.revoke_access_to_course',
  [ContactWorkflowStepActionEnum.SendWebhook]: 'dashboard.automation_rule.action.send_webhook',
  [ContactWorkflowStepActionEnum.GrantAccessToCommunity]:
    'dashboard.automation_rule.action.grant_access_to_community',
  [ContactWorkflowStepActionEnum.RevokeAccessToCommunity]:
    'dashboard.automation_rule.action.revoke_access_to_community',
  [ContactWorkflowStepActionEnum.EnrollInCourseBundle]:
    'dashboard.automation_rule.action.enroll_in_course_bundle',
  [ContactWorkflowStepActionEnum.RevokeAccessToCourseBundle]:
    'dashboard.automation_rule.action.revoke_access_to_course_bundle',
  [ContactWorkflowStepActionEnum.AssignPipelineStage]:
    'dashboard.automation_rule.action.assign_pipeline_stage',
  [ContactWorkflowStepActionEnum.SendSms]: 'dashboard.automation_rule.action.send_sms',
  [ContactWorkflowStepActionEnum.SendToGoogleSheets]:
    'dashboard.automation_rule.action.send_to_google_sheets',
}
